import { PaxAmount } from '@fcom/dapi/interfaces/pax-details.interface';

import { MAX_PAX_AMOUNT, MIN_LEAD_PAX_AMOUNT } from '../store/constants';

export const isValidPaxAmount = ({ adults, c15s, children, infants }: PaxAmount): boolean => {
  if (![adults, c15s, children, infants].every((count) => Number.isInteger(count) && count >= 0)) {
    return false;
  }

  return adults >= MIN_LEAD_PAX_AMOUNT && infants <= adults && adults + c15s + children <= MAX_PAX_AMOUNT;
};
